$(function () {
    $('.slider-selection-recipe').each(function () {
        const id = $(this).attr('id');
        if (id) {
            initializeSliderSelection('#' + id);
        }
    });

    if (typeof initialize === 'function') {
        initialize();
    }

    $(document).on('click', '.open-recipe-modal', function () {
        const recipeId = $(this).data('recipe-id');

        $('.recipe-modal').addClass('hidden');

        const modal = $(`.recipe-modal[data-recipe-id="${recipeId}"]`);
        if (modal.length) {
            modal.removeClass('hidden');
            $('body').css('overflow', 'hidden');
        }
    });

    $(document).on('click', '.menu-close-icon', function () {
        $(this).closest('.recipe-modal').addClass('hidden');
        $('body').css('overflow', '');
    });
});